import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { SecondaryHeader, Footer } from "../components/Frumy";
import { FileText } from "@phosphor-icons/react";

const UPDATED = "2026-06-20";

export default function Termini() {
  const { t } = useI18n();
  const sections = t("terminiSections");

  return (
    <div className="min-h-screen flex flex-col">
      <SecondaryHeader />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12 w-full" data-testid="termini-page">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="grid place-items-center h-12 w-12 rounded-xl bg-emerald-50 text-[var(--frumy-green)]">
            <FileText weight="fill" size={26} aria-hidden />
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-5 text-[var(--heading)]">{t("terminiTitle")}</h1>
          <p className="text-base leading-relaxed text-[var(--text-muted)] mt-4 max-w-xl">{t("terminiIntro")}</p>

          <div className="mt-10 space-y-6">
            {sections.map((s, i) => (
              <motion.section key={i} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }}
                data-testid={`termini-section-${i}`}>
                <h2 className="font-bold text-lg text-[var(--heading)]">{i + 1}. {s.h}</h2>
                <p className="text-sm leading-relaxed text-[var(--text-muted)] mt-1.5">{s.p}</p>
              </motion.section>
            ))}
          </div>

          <p className="text-xs text-[var(--text-muted)] mt-10">{t("terminiUpdated")}: {UPDATED}</p>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
